"use client";

import type { BookCallPopupVariant } from "@/lib/book-call-popup-copy";

type BookCallTriggerIcon = "arrow" | "calendar";

type UseBookCallTriggerPropsOptions = {
  /** Native popup: icon hint for morph animation (`data-book-call-icon`). */
  bookCallIcon?: BookCallTriggerIcon;
  /** Selects popup sidebar + form copy (`data-book-call-variant`). */
  bookCallVariant?: BookCallPopupVariant;
};

/** Shared native booking attributes for all book-call CTAs. */
export function useBookCallTriggerProps(
  options?: UseBookCallTriggerPropsOptions,
) {
  return {
    "data-book-call-trigger": "native" as const,
    ...(options?.bookCallIcon
      ? { "data-book-call-icon": options.bookCallIcon }
      : {}),
    ...(options?.bookCallVariant && options.bookCallVariant !== "default"
      ? { "data-book-call-variant": options.bookCallVariant }
      : {}),
  };
}
